module.exports = __webpack_public_path__ + "media/RandomCat2.b23ebc8e.png";